import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2b9d9363 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _2d690604 = () => interopDefault(import('..\\pages\\artists\\index.vue' /* webpackChunkName: "pages/artists/index" */))
const _33092704 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _c12a30bc = () => interopDefault(import('..\\pages\\mobile\\index.vue' /* webpackChunkName: "pages/mobile/index" */))
const _caef995e = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _3ebd8505 = () => interopDefault(import('..\\pages\\mobile\\about\\index.vue' /* webpackChunkName: "pages/mobile/about/index" */))
const _0f59d1b4 = () => interopDefault(import('..\\pages\\mobile\\artists\\index.vue' /* webpackChunkName: "pages/mobile/artists/index" */))
const _669af522 = () => interopDefault(import('..\\pages\\mobile\\news\\index.vue' /* webpackChunkName: "pages/mobile/news/index" */))
const _2930f10d = () => interopDefault(import('..\\pages\\artists\\opus\\_id.vue' /* webpackChunkName: "pages/artists/opus/_id" */))
const _1fe8ab0e = () => interopDefault(import('..\\pages\\mobile\\artists\\_id.vue' /* webpackChunkName: "pages/mobile/artists/_id" */))
const _04b11797 = () => interopDefault(import('..\\pages\\mobile\\news\\_id.vue' /* webpackChunkName: "pages/mobile/news/_id" */))
const _0cc8b96c = () => interopDefault(import('..\\pages\\artists\\_id.vue' /* webpackChunkName: "pages/artists/_id" */))
const _167cd5f9 = () => interopDefault(import('..\\pages\\news\\_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _2d5ae6a2 = () => interopDefault(import('..\\pages\\mobile\\_.vue' /* webpackChunkName: "pages/mobile/_" */))
const _062bcd11 = () => interopDefault(import('..\\pages\\_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _2b9d9363,
    name: "about___ja"
  }, {
    path: "/artists",
    component: _2d690604,
    name: "artists___ja"
  }, {
    path: "/en",
    component: _33092704,
    name: "index___en"
  }, {
    path: "/mobile",
    component: _c12a30bc,
    name: "mobile___ja"
  }, {
    path: "/news",
    component: _caef995e,
    name: "news___ja"
  }, {
    path: "/zh",
    component: _33092704,
    name: "index___zh"
  }, {
    path: "/en/about",
    component: _2b9d9363,
    name: "about___en"
  }, {
    path: "/en/artists",
    component: _2d690604,
    name: "artists___en"
  }, {
    path: "/en/mobile",
    component: _c12a30bc,
    name: "mobile___en"
  }, {
    path: "/en/news",
    component: _caef995e,
    name: "news___en"
  }, {
    path: "/mobile/about",
    component: _3ebd8505,
    name: "mobile-about___ja"
  }, {
    path: "/mobile/artists",
    component: _0f59d1b4,
    name: "mobile-artists___ja"
  }, {
    path: "/mobile/news",
    component: _669af522,
    name: "mobile-news___ja"
  }, {
    path: "/zh/about",
    component: _2b9d9363,
    name: "about___zh"
  }, {
    path: "/zh/artists",
    component: _2d690604,
    name: "artists___zh"
  }, {
    path: "/zh/mobile",
    component: _c12a30bc,
    name: "mobile___zh"
  }, {
    path: "/zh/news",
    component: _caef995e,
    name: "news___zh"
  }, {
    path: "/en/mobile/about",
    component: _3ebd8505,
    name: "mobile-about___en"
  }, {
    path: "/en/mobile/artists",
    component: _0f59d1b4,
    name: "mobile-artists___en"
  }, {
    path: "/en/mobile/news",
    component: _669af522,
    name: "mobile-news___en"
  }, {
    path: "/zh/mobile/about",
    component: _3ebd8505,
    name: "mobile-about___zh"
  }, {
    path: "/zh/mobile/artists",
    component: _0f59d1b4,
    name: "mobile-artists___zh"
  }, {
    path: "/zh/mobile/news",
    component: _669af522,
    name: "mobile-news___zh"
  }, {
    path: "/en/artists/opus/:id?",
    component: _2930f10d,
    name: "artists-opus-id___en"
  }, {
    path: "/en/mobile/artists/:id",
    component: _1fe8ab0e,
    name: "mobile-artists-id___en"
  }, {
    path: "/en/mobile/news/:id",
    component: _04b11797,
    name: "mobile-news-id___en"
  }, {
    path: "/zh/artists/opus/:id?",
    component: _2930f10d,
    name: "artists-opus-id___zh"
  }, {
    path: "/zh/mobile/artists/:id",
    component: _1fe8ab0e,
    name: "mobile-artists-id___zh"
  }, {
    path: "/zh/mobile/news/:id",
    component: _04b11797,
    name: "mobile-news-id___zh"
  }, {
    path: "/artists/opus/:id?",
    component: _2930f10d,
    name: "artists-opus-id___ja"
  }, {
    path: "/en/artists/:id",
    component: _0cc8b96c,
    name: "artists-id___en"
  }, {
    path: "/en/news/:id",
    component: _167cd5f9,
    name: "news-id___en"
  }, {
    path: "/mobile/artists/:id",
    component: _1fe8ab0e,
    name: "mobile-artists-id___ja"
  }, {
    path: "/mobile/news/:id",
    component: _04b11797,
    name: "mobile-news-id___ja"
  }, {
    path: "/zh/artists/:id",
    component: _0cc8b96c,
    name: "artists-id___zh"
  }, {
    path: "/zh/news/:id",
    component: _167cd5f9,
    name: "news-id___zh"
  }, {
    path: "/en/mobile/*",
    component: _2d5ae6a2,
    name: "mobile-all___en"
  }, {
    path: "/zh/mobile/*",
    component: _2d5ae6a2,
    name: "mobile-all___zh"
  }, {
    path: "/artists/:id",
    component: _0cc8b96c,
    name: "artists-id___ja"
  }, {
    path: "/news/:id",
    component: _167cd5f9,
    name: "news-id___ja"
  }, {
    path: "/en/*",
    component: _062bcd11,
    name: "all___en"
  }, {
    path: "/zh/*",
    component: _062bcd11,
    name: "all___zh"
  }, {
    path: "/mobile/*",
    component: _2d5ae6a2,
    name: "mobile-all___ja"
  }, {
    path: "/",
    component: _33092704,
    name: "index___ja"
  }, {
    path: "/*",
    component: _062bcd11,
    name: "all___ja"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
